import React from 'react';
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Divider, Typography } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

const PhotoActionSheet = ({ open, onClose, onActionClick }) => (
  <Drawer
    anchor="bottom"
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '16px 16px 0 0',
        pb: 2,
      },
    }}
  >
    <Typography variant="caption" align="center" sx={{ color: 'text.secondary', pt: 2, pb: 1 }}>
      Add Photo
    </Typography>
    <Divider />
    <List disablePadding>
      <ListItemButton
        onClick={() => {
          onClose();
          onActionClick('camera');
        }}
      >
        <ListItemIcon>
          <CameraAltIcon />
        </ListItemIcon>
        <ListItemText primary="Take a photo" />
      </ListItemButton>
      <ListItemButton
        onClick={() => {
          onClose();
          onActionClick('gallery');
        }}
      >
        <ListItemIcon>
          <PhotoLibraryIcon />
        </ListItemIcon>
        <ListItemText primary="Choose from library" />
      </ListItemButton>
      <Divider />
      <ListItemButton onClick={onClose} sx={{ justifyContent: 'center' }}>
        <ListItemText primary="Cancel" sx={{ textAlign: 'center', color: 'error.main' }} />
      </ListItemButton>
    </List>
  </Drawer>
);

export default PhotoActionSheet;
